export const useStyles = () => ({
  tableTitle: {
    fontWeight: 'bold',
  },
});